'use strict';
define(['app'], function (app) {
    app.service('AeoService', AeoService);
    AeoService.$inject = ['$q', 'API', '__env'];

    function AeoService($q, API, __env) {
        var apiPath = __env.apiGateway + '/api/v2/aeo';

        function scan(url) {
            var deferred = $q.defer();
            API.post(apiPath + '/scan', {url: url}, true)
                .then(function (response) {
                    var data = response && response.data;
                    if (!data) {
                        deferred.reject(new Error('Invalid AEO scanner response'));
                        return;
                    }
                    deferred.resolve(data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        return {scan: scan};
    }
});
